<template>
    <div class="img-wrapper" v-if="src">
        <div class="img-wrapper-img">
            <div :style="{ width: (showFull ? maxedFullWidth : maxedNotFullWidth) }" >
                <template v-if="!showFull">
                    <template v-if="allowZoom">
                        <zoom-on-hover :img-normal="src" :img-zoom="src" :scale="scale"></zoom-on-hover>
                    </template>
                    <template v-if="!allowZoom">
                        <img v-bind:src="src" />
                    </template>
                </template>
                <template v-if="showFull">
                    <img style="width:100%" v-bind:src="src" />
                </template>
            </div>
        </div>
        <div class="img-wrapper-actions no-print">
            <template v-if="!showFull">
                <v-btn small tile color="primary" @click.stop="showFull=true">
                    {{ $t('expandImage') }}<v-icon size="large">mdi-fullscreen</v-icon>
                </v-btn>
            </template>

            <template v-if="showFull" >
                <v-btn small tile color="primary" @click.stop="showFull=false" >
                    {{ $t('colapseImage') }}<v-icon size="large">mdi-fullscreen-exit</v-icon>
                </v-btn>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExamImg',
    props: {
        scale : {
            type : Number,
            default : 2
        },
        allowZoom: {
            type : Boolean,
            default : true
        },
        src : String,
        allowFull: {
            type : Boolean,
            default : true
        },
        initialShowFull: {
            type : Boolean,
            default : false
        },
        fullWidth: {
            type : String,
            default : "70vw"
        },
        notFullWidth: {
            type : String,
            default : "40vw"
        },
    },
    data() {
        return {
           maxWidth : undefined,
           showFull : this.initialShowFull,
           maxedFullWidth : this.fullWidth,
           maxedNotFullWidth : this.notFullWidth
        }
    },
    methods: {

    },
    mounted() {
        const examContainer = document.getElementById("examTopSection");
        if(examContainer){
            const width = examContainer.offsetWidth;
            this.maxWidth = width;
            this.maxedFullWidth = "min("+this.fullWidth+", "+this.maxWidth+"px)";
            this.maxedNotFullWidth = "min("+this.notFullWidth+", "+this.maxWidth+"px)";

        }
    },
}
</script>

<style scoped>
.img-wrapper-actions{
    text-align: end;
}
.img-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
}
.img-wrapper-img{
    text-align: -webkit-center;
}

</style>